import { styled } from 'styled-components';

export const Wrapper = styled.div`
  display: grid;
  place-content: center;
  height: 100vh;
  padding: var(--spacing-24) var(--spacing-8);
  text-align: center;
`;
export const Text = styled.p`
  margin: 0;
  white-space: pre-line;
`;
